export default function GoogleAnalytics() {
  return null;
}
